<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[2].header | translate"
        [subtitle]="steps[2].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="2" />
    </div>
  </soft-page-header>

  <div class="soft-overline mt-4">
    {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.MENGE' | translate}}
  </div>

  <div class="flex flex-col items-end justify-end w-full">
    @if (artikel(); as artikel) {
    <soft-ds-quantity-input
      [size]="'xl'"
      [value]="(artikel?.menge_inv ?? 0) > 0 ? (artikel.menge_inv ?? 0) : artikel.menge"
      [unit]="artikel.einheit.arteh ?? null"
      [float]="true"
      (valueChange)="onMengeChange($event)"
    />
    <soft-ds-button (click)="openUnitEntryModal(artikel)">Mengeneingabe</soft-ds-button>
    }
  </div>

  @if (loading$ | async) {
  <soft-blocking-loading-spinner class="top-0 right-0"></soft-blocking-loading-spinner>
  }

  <soft-page-footer>
    <button
      type="button"
      class="soft-button primary w-full h-20"
      (click)="onSubmit()"
    >
      {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.SUBMIT' | translate}}
    </button>
  </soft-page-footer>
</soft-page>
